import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  host: { 'class': 'layout login' }
})
export class AuthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
